import React from "react";
import { useState } from "react";
import { Select, MenuItem } from '@mui/material';
import Swal from "sweetalert2";
import Divider from "@mui/material/Divider";


// Iconos
import * as Icons from "@mui/icons-material"
import api from "../../services/api";

// Archivo scss
import "../Create/Create.scss"

const Create = ( {onClose, onCreated} ) =>{


    const [selectedIcon, setSelectedIcon] = useState("");// "selectedIcon" estado actual, "setSelectedIcon" actualizar nuestro estado
    const iconNames = Object.keys(Icons);// usar todos los iconos disponibles
    const [name, setName] = useState(""); // Estado para almacenar el nombre
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    
    // filtrar los iconos de 6 en 6
    const filteredIcons = iconNames.filter((_, index) => index % 6 === 0).slice(0, 1000);

    

    //funcion para cerrar
    const handleClose = ()=>{
        onClose();
    }

    
    
    //funcion para crear los almacenes
    const create = async () => {
        const nombre = name.trim();

        // Validaciones con Swal
        if (!nombre || !selectedIcon) {
            await Swal.fire({
            icon: "warning",
            title: "Faltan datos",
            text: "Por favor, completa nombre e ícono.",
            confirmButtonText: "Ok",
            });
            return;
        }

        if (!token) {
            await Swal.fire({
            icon: "error",
            title: "Sesión no válida",
            text: "No hay token. Inicia sesión de nuevo.",
            confirmButtonText: "Ok",
            });
            return;
        }

        // Loading
        Swal.fire({
            title: "Creando almacén...",
            text: "Espera un momento",
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
            Swal.showLoading();
            },
        });

        try {
            const response = await api.post(
             "/almacenes",
            { nombre, icono: selectedIcon },
            {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
                },
            }
            );

            // Cierra loading y muestra éxito
            Swal.close();

            await Swal.fire({
            icon: "success",
            title: "¡Listo!",
            text: response.data?.message || "Almacén creado correctamente.",
            confirmButtonText: "Ok",
            });

            onClose();
            await onCreated?.();
            

        } catch (error) {
            Swal.close();

            // Mensaje bien armado por tipo de error
            const status = error?.response?.status;
            const data = error?.response?.data;

            // Laravel típico: errors: { campo: ["msg"] }
            const firstValidationError =
            data?.errors ? Object.values(data.errors)?.flat()?.[0] : null;

            let msg =
            data?.message ||
            firstValidationError ||
            (status === 401
                ? "Token inválido o expirado. Inicia sesión de nuevo."
                : status === 422
                ? "Hay datos inválidos. Revisa el formulario."
                : "Error al crear el almacén. Intenta de nuevo.");

            await Swal.fire({
            icon: "error",
            title: "No se pudo crear",
            text: msg,
            confirmButtonText: "Ok",
            });

            

            console.error("Error al crear el almacén:", error);
        }
    
    };



    

    // cambio de icono
    const handleIconChange = (event) => {
        setSelectedIcon(event.target.value);
    };


    

    // Actualiza el estado con el valor del input
    const handleNameChange = (event) => {
        setName(event.target.value); 
    };


   
    
   
    
    
    
    

    return (
    <>
        <div className="body-forms">
        {/* Header */}
        <div className="Header">
            <div className="header-left">
                <h2 className="header-title">Crear almacén</h2>
                <p className="header-subtitle">Define el nombre y selecciona un ícono</p>
            </div>
            <div className="buttonc-cont">
                <button className="button-close" onClick={handleClose} aria-label="Cerrar">
                    ✕
                </button>
            </div>
            
        </div>

        <Divider />

        {/* Content */}
        <div className="general-container">
            {/* Preview */}
            <div className="design-container">
                <div className="design">
                    <div className="preview-top">
                    <div className="name-selected">{name || "Nombre del almacén"}</div>
                    </div>

                    <div className="Icon-selected">
                    {selectedIcon
                        ? React.createElement(Icons[selectedIcon], {
                            style: { fontSize: "92px" },
                            className: "preview-icon",
                        })
                        : <div className="preview-icon placeholder">?</div>}
                    </div>

                    
                </div>
            </div>

            {/* Form */}
            <div className="container-form">
            <div className="forms">
                <div className="form-row">
                <label htmlFor="nombre-almacen" className="label-name">Nombre</label>
                <input
                    className="input-name"
                    type="text"
                    id="nombre-almacen"
                    name="nombre-almacen"
                    placeholder="Ej. Central"
                    value={name}
                    onChange={handleNameChange}
                    maxLength="21"
                />
                <small className="helper">{name.length}/21</small>
                </div>

                <div className="form-row">
                <label htmlFor="icono" className="label-icon">Ícono</label>

                <Select
                    className="selected-icon"
                    id="icono"
                    value={selectedIcon}
                    onChange={handleIconChange}
                    displayEmpty
                    renderValue={(value) => {
                        // cuando NO hay selección
                        if (!value) {
                        return <span className="select-placeholder">Selecciona un ícono</span>;
                        }

                        // cuando SÍ hay selección: muestra el icono elegido
                        const IconComp = Icons[value];
                        return (
                        <span className="select-value">
                            {IconComp ? <IconComp className="icon-selected" /> : null}
                        </span>
                        );
                    }}
                    MenuProps={{
                        PaperProps: { className: "icon-menu-paper" }
                    }}
                    >
                    {filteredIcons.map((iconName) => (
                        <MenuItem key={iconName} value={iconName} className="icon-item">
                        {React.createElement(Icons[iconName], { className: "icon-option" })}
                        </MenuItem>
                    ))}
                </Select>

                </div>
            </div>
            </div>
        </div>

        {/* Footer */}
        <div className="footer-select">
            <button className="boton_crear" onClick={create}>
            Crear
            </button>
        </div>
        </div>
    </>
);
  

};
export default Create